module.exports = __webpack_public_path__ + "static/media/day05.7aad2706.jpg";